import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";

export const useInboundFreightByTerminal = (
  originCity?: string | null,
  status?: string | null,
  manifest?: string | null,
  trailer?: string | null,
  etaFrom?: string | null,
  etaTo?: string | null
) => {
  const userState = useSelector(userSelector);
  const terminalId = userState.activeTerminal?.id;

  const { isFetching, isLoading, data, error } =
    useQuery<any[]>({
      queryKey: [
        QUERY_KEYS.INBOUND_FREIGHT_BY_TERMINAL,
        terminalId,
        originCity,
        status,
        manifest,
        trailer,
        etaFrom,
        etaTo,
      ],
      queryFn: async () => {
        let params: any = {};
        if (originCity) {
          params.originCity = originCity;
        }
        if (status) {
          params.status = status;
        }
        if (manifest) {
          params.manifest = manifest;
        }
        if (trailer) {
          params.trailer = trailer;
        }
        if (etaFrom) {
          params.etaFrom = etaFrom;
        }
        if (etaTo) {
          params.etaTo = etaTo;
        }

        const response = await apiQueryAdapter.query<any[]>(`/linehaul-manifests/terminal/${terminalId}`,
          "GET",
          { params }
        );

        return response.data;
      },
      enabled: Boolean(terminalId),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: 30 * 1000, // Poll every 30 seconds for live unloading progress updates
    })
  return { isFetching, isLoading, data, error };
}